import { render, staticRenderFns } from "./AddRequest.vue?vue&type=template&id=64cf9f66"
import script from "./AddRequest.vue?vue&type=script&lang=js"
export * from "./AddRequest.vue?vue&type=script&lang=js"
import style0 from "./AddRequest.vue?vue&type=style&index=0&id=64cf9f66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports